import './nosotros.scss'

const Nosotros = () => {
    return <>
    <section className="nosotros" id="nosotros" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="50">
        <h1 className="text-uppercase">Nosotros</h1>
        <div className="nosotros-article mx-auto pt-4 ">        
            <p>Inrush Ingeniería es una empresa joven formada por un grupo de profesionales con una vasta experiencia en el desarrollo de proyectos y obras de infraestructura eléctrica y electromecánica, en los niveles de baja, media, alta y extra alta tensión.</p><p> Brindamos soluciones integrales en todas las etapas que componen un proyecto, como ser estudio de pliego, desarrollo de ingeniería, construcción y puesta en servicio.
            </p>
            <p>La confianza depositada por nuestros clientes avala nuestra trayectoria en el sector.</p>
        </div>
    </section>
    </>

}
export default Nosotros